import {
  Table,
  TableBody,
  TableHead,
  TableFooter,
  Typography,
} from '@mui/material';
import React from 'react';
import {
  StyledBodyCell,
  StyledHeadCell,
  StyledTableRow,
  StyledFooterCell,
  StyledSkeleton,
} from '../components';

export function LoadingTransactionTable() {
  return (
    <Table sx={{borderCollapse: 'separate'}}>
      <TableHead>
        <StyledTableRow sx={{border: '0 !important'}}>
          <StyledHeadCell>
            <Typography>Internal ID</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>Classified JE Account Line</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>JE Account lines</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>Amount</Typography>
          </StyledHeadCell>
          <StyledHeadCell
            sx={{width: '50px', minWidth: '50px', maxWidth: '50px'}}
          />
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {Array.from({length: 10}).map((_, idx) => (
          <StyledTableRow key={`tablebodyrow-${idx}`}>
            {Array.from({length: 4}).map((_, idx) => (
              <StyledBodyCell key={`body1-${idx}`}>
                <StyledSkeleton />
              </StyledBodyCell>
            ))}
            <StyledBodyCell sx={{width: '50px'}}>
              <StyledSkeleton />
            </StyledBodyCell>
          </StyledTableRow>
        ))}
      </TableBody>
      <TableFooter>
        <StyledTableRow>
          <StyledFooterCell colSpan={3} />
          <StyledFooterCell>
            <StyledSkeleton />
          </StyledFooterCell>
          <StyledFooterCell />
        </StyledTableRow>
      </TableFooter>
    </Table>
  );
}
